import authHeader from 'srcReact/helpers/auth-header'
import { getCurrentLanguageFromCookie, getDeviceId } from 'srcReact/helpers/utils'
import { isEmpty } from 'srcReact/helpers/validator'
import { doRequestAxios } from 'srcReact/helpers/apiHelper'
export const userService = {
  login,
  loginWithApp,
  loginWithWorkplace,
  getByOrganizationId,
  getProfile,
  subscribeNewsletter,
  submitFormLanding,
  isAuthorized,
  userLogout,
  displayCTA,
  closeCTA,
  openCTA
}

function login(email, password, orgId, origin, keepLoggedIn, triggeredAction) {
  const language = getCurrentLanguageFromCookie()
  const deviceId = getDeviceId()
  let data = { email, password, keep_logged_in: keepLoggedIn ? 1 : 0, language, device_id: deviceId }
  if (orgId && orgId > 0) {
    data.organization_id = orgId
  }
  if (origin === 'sso') {
    data.orig = origin
  }
  if (!isEmpty(triggeredAction)) {
    data.triggered_action = triggeredAction
  }
  const requestOptions = {
    method: 'POST',
    crossDomain: true,
    headers: authHeader(0),
    params: data
  }
  return doRequestAxios(`/login`, requestOptions)
}
function loginWithApp(email, password, appName, code) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader(0),
    data: {
      email,
      password,
      name: appName,
      code
    }
  }
  return doRequestAxios(`/v2/external-auth`, requestOptions)
}

function loginWithWorkplace(email, password, organizationId, workplaceIds) {
  const deviceId = getDeviceId()
  const requestOptions = {
    method: 'POST',
    headers: authHeader(0),
    params: {
      email,
      password,
      organization_id: organizationId,
      workplace_ids: workplaceIds,
      device_id: deviceId
    }
  }
  return doRequestAxios(`/v2/user/mixr-authentification/activate`, requestOptions)
}

function userLogout() {
  const requestOptions = {
    method: 'POST',
    headers: authHeader()
  }
  return doRequestAxios(`/logout`, requestOptions)
}

function getByOrganizationId(id, filters) {
  const params = `who=${!filters ? '["team"]' : `[${filters}]`}`
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }
  return doRequestAxios(`/organization/member/list?organization_id=${id}&${params}`, requestOptions)
}

function getProfile(id) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }
  return doRequestAxios(`/profile/${id}`, requestOptions)
}

function subscribeNewsletter(email) {
  const language = getCurrentLanguageFromCookie()
  const requestOptions = {
    method: 'POST',
    headers: authHeader(0),
    params: { email, language }
  }
  return doRequestAxios(`/newsletter/email`, requestOptions)
}

function submitFormLanding(form) {
  const language = getCurrentLanguageFromCookie()
  const requestOptions = {
    method: 'POST',
    headers: authHeader(0),
    params: form
  }
  return doRequestAxios(`/contact/message-landing?language=${language}`, requestOptions)
}

function isAuthorized(service, params) {
  const additional_params = params != '' ? `&${params}` : ''

  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }
  return doRequestAxios(`/status/client?service=${service}${additional_params}`, requestOptions)
}

function displayCTA(ctaCategory, entityId) {
  const params = { cta_category: ctaCategory }
  if (entityId > 0) {
    params.id_entity = entityId
  }
  const requestOptions = {
    method: 'PUT',
    headers: authHeader(),
    data: params
  }
  return doRequestAxios(`/v2/user/cta/display`, requestOptions)
}

function closeCTA(ctaCategory) {
  const requestOptions = {
    method: 'PUT',
    headers: authHeader(),
    data: { cta_category: ctaCategory }
  }
  return doRequestAxios(`/v2/user/cta/close`, requestOptions)
}

function openCTA(ctaCategory, ctaType) {
  const requestOptions = {
    method: 'PUT',
    headers: authHeader(),
    data: { cta_category: ctaCategory, cta_type: ctaType }
  }
  return doRequestAxios(`/v2/user/cta/open`, requestOptions)
}
